module.exports = __webpack_public_path__ + "img/icon_h-convenience.afa08c0e.png";